/**
 * Returns a type guard to narrow a freeform string into string union
 *
 * Keep in mind that the provided value list must have a correct union type
 * and not infer to string[], usually this means using `as const` when declaring.
 *
 * @example
 * assertType(isStringFromList(['foo', 'bar'] as const)(userInput));
 */
export const isStringFromList =
  <T extends string>(list: readonly T[]) =>
  (x: string): x is T =>
    list.includes(x as T);
